/*
 * @format
 */

/*
 * The sentences more than one topic tells the reader.
 *
 * Changing modes and Setting Plus Hours both open with the same two watch
 * screens — the mode pill on the zone screen, then the picker — so they say the
 * same thing about them. Written once here because they did drift: the two
 * pages described the same illustration in different words, one naming the mode
 * icon and the other the lower portion of the screen.
 */
export const OPEN_MODE_PICKER =
  'You can change the heating mode for a zone by tapping on the mode icon on ' +
  'the home screen.';

export const CHOOSE_MODE = 'You can then select the heating mode you desire.';
